import React, { useEffect, useState } from "react";
import { useCompare } from "properties/propertyCard/components/favorite/compare-provider";
import { useTranslation } from "react-i18next";
import { clsx } from "clsx";
import { Square, SquareCheck } from "lucide-react";
import { COMMON_RESOURCE } from "_common/resources/BaseResourceStore";
import { PROPERTY_TYPE } from "properties/_models/PropertyMdl";

interface Props {
    propertyId: string;
    itemType: PROPERTY_TYPE;
}

export default function PropertyFavoriteCardCheckbox({ propertyId, itemType }: Props) {
    const { toggleCompare, itemsSelected, isAlreadyCompared } = useCompare();

    const { t } = useTranslation();
    const [isDisabled, setIsDisabled] = useState(false);

    useEffect(() => {
        if (itemsSelected.length >= 5 && !isAlreadyCompared(propertyId)) {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }
    }, [itemsSelected, propertyId]);

    const handleCheckboxChange = () => {
        toggleCompare({ itemId: propertyId, resource: COMMON_RESOURCE.PROPERTIES, type: itemType });
    };

    return (
        <div
            className={clsx(
                "absolute bottom-2 right-2 bg-white h-[35px] px-3 rounded-full flex flex-row justify-center items-center mr-10",
                { "cursor-default": isDisabled },
            )}
            onClick={(event: React.MouseEvent) => {
                event.stopPropagation();
                event.preventDefault();
                handleCheckboxChange();
            }}
        >
            {isAlreadyCompared(propertyId) ? (
                <SquareCheck size={15} className="text-[#1A3A45]" />
            ) : (
                <Square size={15} className="text-[#1A3A45]" />
            )}
            <div className="text-sm ml-1">{t("propertiesPage.compare")}</div>
        </div>
    );
}
